import { CircularProgress, FormControl, FormHelperText, InputLabel,  MenuItem, Select } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useEffect } from "react";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
interface CustomSelectProps {
  readonly id: string;
  readonly value: string | number | object;
  readonly name?: string;
  readonly fullWidth?: boolean;
  readonly autoWidth?: boolean;
  readonly required?: boolean;
  readonly disabled?: boolean;
  readonly menuList: Array<string | number | object>;
  readonly setState: (state: any) => void;
  readonly defaultValue?: string;
  readonly helperText?: string;
  readonly infoText?: string;
  readonly errorMessage?: string;
  readonly label?:string;
  readonly loading?:boolean;
}
const useStyles = makeStyles({
  
  select: {
   
    '&:focus': {
      backgroundColor: '#fff',
    },
  },
});

function CustomSelect(props: CustomSelectProps) {
  const classes = useStyles()
  const {
    id = "",
    value,
    name = "",
    fullWidth = true,
    autoWidth = true,
    required = true,
    disabled,
    menuList = ["No Data Available"],
    setState,
    defaultValue,
    helperText = "",
    infoText = "",
    errorMessage = "",
    label='',
    loading=false,
  } = props;
useEffect(()=>{getIconComponent()},[loading])
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { value } = event.target;
    setState(value);
  };
  const getColor: any = () => {
    if (value || defaultValue) {
      if (disabled) {
        return "#B9B9AC";
      } else {
        return "#000";
      }
    } else {
      return "#B9B9AC";
    }
  };
  const getIconComponent = () => {
    if (loading) {
      return <CircularProgress color="primary" className="circularLoader" />;
    } else {
      return <ArrowDropDownIcon />;
    }
  };
  return (
    <FormControl variant="outlined">
      <InputLabel>{label}</InputLabel>
      <Select
        id={id}
        value={defaultValue ?? value}
        name={name}
        fullWidth={fullWidth}
        autoWidth={autoWidth}
        required={required}
        disabled={disabled}
        onChange={(evt) => {
          handleChange(evt);
        }}
        classes={{ select: classes.select }}
        style={{ color: getColor(),  textAlign: "left", height: 48,  }}
        inputProps={{ "aria-label": "Without label" }}
        displayEmpty={true}
        label={label}
        IconComponent	={() =>getIconComponent()}
      >
        {infoText && (
          <MenuItem value="" disabled>
            {infoText}
          </MenuItem>
        )}

        {menuList.map((option: any) => {
          if (Array.isArray(option)) {
            return (
              <MenuItem key={option[0]} value={option[0]} style={{ width: fullWidth ? "42rem" : "12rem" }}>
                {option[1] + " " + option[0]}
              </MenuItem>
            );
          }else if(typeof option === "object"){
            return (
              <MenuItem key={option.val} value={option} style={{ width: fullWidth ? "42rem" : "12rem" }}>
                {option.key}
              </MenuItem>
            );
          }
           else {
            return (
              <MenuItem key={option} value={option} style={{ width: fullWidth ? "42rem" : "12rem" }}>
                {option}
              </MenuItem>
            );
          }
        })}
      </Select>
      <FormHelperText style={{ fontWeight: "400", color: "#424242", fontSize: "14px" , marginLeft:'0px'}}>{helperText}</FormHelperText>
      {errorMessage && (
        <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>{errorMessage}</FormHelperText>
      )}
    </FormControl>
  );
}

export default CustomSelect;
